import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';
import { useTextListContext } from '../TextList.Context/index.es.js';

const TextListItemIcon = ({ name, className })=>{
    const { type, size } = useTextListContext();
    if (type !== 'icon') {
        throw new Error('pass type="icon" to TextList to render icons in list item');
    }
    return jsx(Icon, {
        className: classNames('cb-text-list-item-icon', className),
        name: name,
        size: size === 'base' ? 24 : 20
    });
};
TextListItemIcon.displayName = 'TextList.Item.Icon';

export { TextListItemIcon };
//# sourceMappingURL=TextList.Item.Icon.es.js.map
